import POHeaderEdit from "src/components/UserActions/Handlers/Validation/OverrideMetadata/PurchaseOrder/POHeaderEdit";
import POLineItemEdit from "src/components/UserActions/Handlers/Validation/OverrideMetadata/PurchaseOrder/POLineItemEdit";
import RelatedDocumentEdit from "src/components/UserActions/Handlers/Validation/OverrideMetadata/RelatedDocuments/RelatedDocumentEdit";
import {
  OverriddenMetadataEntry,
  type ValidationUserActionHandler,
} from "src/components/UserActions/Handlers/Validation/types";

const EDIT_COMPONENT_BY_ATTRIBUTE = new Map()
  .set(OverriddenMetadataEntry.HeaderPurchaseOrder, POHeaderEdit)
  .set(OverriddenMetadataEntry.LineItemPurchaseOrder, POLineItemEdit)
  .set(OverriddenMetadataEntry.RelatedDocument, RelatedDocumentEdit);

const handleOverrideMetadata: ValidationUserActionHandler = async (
  _,
  { attribute }
) => {
  return EDIT_COMPONENT_BY_ATTRIBUTE.get(attribute);
};

export default handleOverrideMetadata;
